import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0.5 0 15 10">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M10.05 0h-5c-2.76 0-5 2.24-5 5s2.24 5 5 5h5c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8.333A3.331 3.331 0 0 1 6.717 5a3.331 3.331 0 0 1 3.333-3.333A3.332 3.332 0 0 1 13.383 5a3.332 3.332 0 0 1-3.333 3.333z"
    />
  </SvgIcon>
);

export default Icon;
